import jQuery from "jquery";

window.$ = window.jQuery = jQuery;
import "bootstrap";
import "jquery-ui-dist/jquery-ui.js";
import "slick-carousel";
import "../style/main.scss";
import { createPopper } from "@popperjs/core";
import $ from "jquery";

// Multi-language translations
const translations = {
  it: {
    // Hero Section
    heroGreeting: "Ciao, sono Vanderlei Bailo",
    heroTagline:
      "Fullstack Developer | 10+ anni di esperienza | Trasformo idee in soluzioni digitali innovative",
    heroButton: "Iniziamo il tuo progetto",
    heroAlt: "Foto di Vanderlei Bailo, sviluppatore fullstack",

    // About Section
    aboutTitle: "Su di me",
    aboutSubtitle: "Chi è Vanderlei Bailo?",
    aboutDescription:
      "Sono un <strong>Fullstack Developer</strong> con oltre 10 anni di esperienza nella progettazione e sviluppo di soluzioni web innovative. Specializzato in tecnologie moderne come React, Node.js, PHP e Docker, trasformo idee complesse in applicazioni scalabili e performanti. La mia passione è risolvere sfide tecniche con codice pulito e architetture robuste.",
    aboutPoint1: "<strong>10+ anni</strong> di esperienza in sviluppo web",
    aboutPoint2: "Expert in <strong>React, Node.js, PHP, Python</strong>",
    aboutPoint3: "Specialista in <strong>Docker, DevOps e Cloud</strong>",
    aboutPoint4: "Progetti per <strong>PMI e grandi aziende</strong>",

    // Mission Section
    missionTitle: "Riepilogo Professionale",
    missionDescription:
      "Professionista multidisciplinare con oltre 30 anni di esperienza nel supporto IT, sviluppo front-end e full-stack, progettazione meccanica e programmazione CNC. Specializzato nel supporto helpdesk IT e nella progettazione meccanica utilizzando SolidWorks, Fusion 360 e tecnologie di stampa 3D. Altamente adattabile, autodidatta e appassionato di innovazione, design e tecnologia.",

    // Approach Section
    approachTitle: "Il mio Approccio",
    approachPoint1:
      "<strong>Analisi strategica:</strong> Studio a fondo le esigenze del business per proporre la soluzione più efficace.",
    approachPoint2:
      "<strong>Tecnologie moderne:</strong> Utilizzo stack tecnologici all'avanguardia per prestazioni ottimali.",
    approachPoint3:
      "<strong>Codice di qualità:</strong> Sviluppo seguendo best practices per garantire manutenibilità e scalabilità.",
    approachPoint4:
      "<strong>Collaborazione attiva:</strong> Lavoro in stretta collaborazione con i team per allineare obiettivi tecnici e business.",
    approachPoint5:
      "<strong>Formazione continua:</strong> Mi aggiorno costantemente per offrire sempre soluzioni innovative.",

    // Services Section
    servicesTitle: "Le mie Competenze",
    servicesSubtitle:
      "Soluzioni tecnologiche complete per far crescere il tuo business",
    service1Title: "Sviluppo Web",
    service1Desc:
      "Applicazioni web moderne e scalabili con React, Node.js, Python",
    service2Title: "E-commerce",
    service2Desc:
      "Store online performanti con Magento, WooCommerce e soluzioni custom",
    service3Title: "CMS & WordPress",
    service3Desc:
      "Siti corporate, blog e portali con gestione contenuti avanzata",
    service4Title: "DevOps & Cloud",
    service4Desc:
      "Deployment automatizzato, Docker, CI/CD e infrastrutture cloud",

    // Contact Section
    contactTitle: "Vuoi parlare con me?",
    contactSubtitle:
      "Sono sempre disponibile per discutere nuovi progetti e opportunità di collaborazione.",
    contactNamePlaceholder: "Nome",
    contactEmailPlaceholder: "E-mail",
    contactSubjectPlaceholder: "Soggetto",
    contactMessagePlaceholder: "Messaggio",
    contactButton: "Invia Messaggio",
    contactSending: "Invio in corso...",
    portfolioButton: "Discuti il tuo progetto",

    // Portfolio Projects
    portfolioMagentoTitle: "E-commerce Magento",
    portfolioMagentoDesc:
      "Store online completo con sistema di pagamento integrato e gestione avanzata del catalogo prodotti",
    portfolioWordPressTitle: "Sito Corporate WordPress",
    portfolioWordPressDesc:
      "Sito aziendale responsive con CMS personalizzato, SEO ottimizzato e sistema di gestione contenuti avanzato",
    portfolioReactTitle: "Web App React",
    portfolioReactDesc:
      "Applicazione web moderna SPA con dashboard amministrativa, autenticazione e API REST integrata",
    portfolioMechanicalTitle: "Design Meccanico e CNC",
    portfolioMechanicalDesc:
      "Design meccanico utilizzando SolidWorks, Fusion 360 e tecnologie di impressione 3D per prototipazione e produzione industriale",
    portfolioITSupportTitle: "Supporto IT",
    portfolioITSupportDesc:
      "Specializzato in supporto helpdesk IT, manutenzione sistemi e risoluzione di problemi tecnici complessi",
  },

  en: {
    // Hero Section
    heroGreeting: "Hi, I'm Vanderlei Bailo",
    heroTagline:
      "Fullstack Developer | 10+ years experience | Transforming ideas into innovative digital solutions",
    heroButton: "Let's start your project",
    heroAlt: "Photo of Vanderlei Bailo, fullstack developer",

    // About Section
    aboutTitle: "About me",
    aboutSubtitle: "Who is Vanderlei Bailo?",
    aboutDescription:
      "I'm a <strong>Fullstack Developer</strong> with over 10 years of experience in designing and developing innovative web solutions. Specialized in modern technologies like React, Node.js, PHP and Docker, I transform complex ideas into scalable and high-performing applications. My passion is solving technical challenges with clean code and robust architectures.",
    aboutPoint1: "<strong>10+ years</strong> of web development experience",
    aboutPoint2: "Expert in <strong>React, Node.js, PHP, Python</strong>",
    aboutPoint3: "Specialist in <strong>Docker, DevOps & Cloud</strong>",
    aboutPoint4: "Projects for <strong>SMEs and large companies</strong>",

    // Mission Section
    missionTitle: "PROFESSIONAL SUMMARY",
    missionDescription:
      "Multidisciplinary professional with over 30 years of experience in IT support, front-end and full-stack development, mechanical design, and CNC programming. Specialized in IT helpdesk support and mechanical design using SolidWorks, Fusion 360, and 3D printing technologies. Highly adaptable, self-taught, and passionate about innovation, design, and technology.",

    // Approach Section
    approachTitle: "My Approach",
    approachPoint1:
      "<strong>Strategic analysis:</strong> I thoroughly study business needs to propose the most effective solution.",
    approachPoint2:
      "<strong>Modern technologies:</strong> I use cutting-edge tech stacks for optimal performance.",
    approachPoint3:
      "<strong>Quality code:</strong> I develop following best practices to ensure maintainability and scalability.",
    approachPoint4:
      "<strong>Active collaboration:</strong> I work closely with teams to align technical and business objectives.",
    approachPoint5:
      "<strong>Continuous learning:</strong> I constantly update myself to always offer innovative solutions.",

    // Services Section
    servicesTitle: "My Skills",
    servicesSubtitle: "Complete technological solutions to grow your business",
    service1Title: "Web Development",
    service1Desc:
      "Modern and scalable web applications with React, Node.js, Python",
    service2Title: "E-commerce",
    service2Desc:
      "High-performing online stores with Magento, WooCommerce and custom solutions",
    service3Title: "CMS & WordPress",
    service3Desc:
      "Corporate sites, blogs and portals with advanced content management",
    service4Title: "DevOps & Cloud",
    service4Desc:
      "Automated deployment, Docker, CI/CD and cloud infrastructures",

    // Contact Section
    contactTitle: "Want to talk with me?",
    contactSubtitle:
      "I'm always available to discuss new projects and collaboration opportunities.",
    contactNamePlaceholder: "Name",
    contactEmailPlaceholder: "E-mail",
    contactSubjectPlaceholder: "Subject",
    contactMessagePlaceholder: "Message",
    contactButton: "Send Message",
    contactSending: "Sending...",
    portfolioButton: "Discuss your project",

    // Portfolio Projects
    portfolioMagentoTitle: "Magento E-commerce",
    portfolioMagentoDesc:
      "Complete online store with integrated payment system and advanced product catalog management",
    portfolioWordPressTitle: "Corporate WordPress Site",
    portfolioWordPressDesc:
      "Responsive corporate website with custom CMS, SEO optimized and advanced content management system",
    portfolioReactTitle: "React Web App",
    portfolioReactDesc:
      "Modern SPA web application with administrative dashboard, authentication and integrated REST API",
    portfolioMechanicalTitle: "Mechanical Design & CNC",
    portfolioMechanicalDesc:
      "Mechanical design using SolidWorks, Fusion 360 and 3D printing technologies for prototyping and industrial production",
    portfolioITSupportTitle: "IT Support",
    portfolioITSupportDesc:
      "Specialized in IT helpdesk support, system maintenance and complex technical problem resolution",
  },

  pt: {
    // Hero Section
    heroGreeting: "Olá, eu sou Vanderlei Bailo",
    heroTagline:
      "Desenvolvedor Fullstack | 10+ anos de experiência | Transformo ideias em soluções digitais inovadoras",
    heroButton: "Vamos começar seu projeto",
    heroAlt: "Foto de Vanderlei Bailo, desenvolvedor fullstack",

    // About Section
    aboutTitle: "Sobre mim",
    aboutSubtitle: "Quem é Vanderlei Bailo?",
    aboutDescription:
      "Sou um <strong>Desenvolvedor Fullstack</strong> com mais de 10 anos de experiência no design e desenvolvimento de soluções web inovadoras. Especializado em tecnologias modernas como React, Node.js, PHP e Docker, transformo ideias complexas em aplicações escaláveis e performáticas. Minha paixão é resolver desafios técnicos com código limpo e arquiteturas robustas.",
    aboutPoint1:
      "<strong>10+ anos</strong> de experiência em desenvolvimento web",
    aboutPoint2: "Expert em <strong>React, Node.js, PHP, Python</strong>",
    aboutPoint3: "Especialista em <strong>Docker, DevOps e Cloud</strong>",
    aboutPoint4: "Projetos para <strong>PMEs e grandes empresas</strong>",

    // Mission Section
    missionTitle: "Resumo Profissional",
    missionDescription:
      "Profissional multidisciplinar com mais de 30 anos de experiência em suporte de TI, desenvolvimento front-end e full-stack, design mecânico e programação CNC. Especializado em suporte de helpdesk de TI e design mecânico utilizando SolidWorks, Fusion 360 e tecnologias de impressão 3D. Altamente adaptável, autodidata e apaixonado por inovação, design e tecnologia",

    // Approach Section
    approachTitle: "Minha Abordagem",
    approachPoint1:
      "<strong>Análise estratégica:</strong> Estudo a fundo as necessidades do negócio para propor a solução mais eficaz.",
    approachPoint2:
      "<strong>Tecnologias modernas:</strong> Utilizo stacks tecnológicos de ponta para performance otimizada.",
    approachPoint3:
      "<strong>Código de qualidade:</strong> Desenvolvo seguindo melhores práticas para garantir manutenibilidade e escalabilidade.",
    approachPoint4:
      "<strong>Colaboração ativa:</strong> Trabalho em estreita colaboração com equipes para alinhar objetivos técnicos e de negócio.",
    approachPoint5:
      "<strong>Aprendizado contínuo:</strong> Me atualizo constantemente para sempre oferecer soluções inovadoras.",

    // Services Section
    servicesTitle: "Minhas Competências",
    servicesSubtitle:
      "Soluções tecnológicas completas para fazer seu negócio crescer",
    service1Title: "Desenvolvimento Web",
    service1Desc:
      "Aplicações web modernas e escaláveis com React, Node.js, Python",
    service2Title: "E-commerce",
    service2Desc:
      "Lojas online performáticas com Magento, WooCommerce e soluções customizadas",
    service3Title: "CMS & WordPress",
    service3Desc:
      "Sites corporativos, blogs e portais com gestão avançada de conteúdo",
    service4Title: "DevOps & Cloud",
    service4Desc:
      "Deploy automatizado, Docker, CI/CD e infraestruturas em nuvem",

    // Contact Section
    contactTitle: "Quer falar comigo?",
    contactSubtitle:
      "Estou sempre disponível para discutir novos projetos e oportunidades de colaboração.",
    contactNamePlaceholder: "Nome",
    contactEmailPlaceholder: "E-mail",
    contactSubjectPlaceholder: "Assunto",
    contactMessagePlaceholder: "Mensagem",
    contactButton: "Enviar Mensagem",
    contactSending: "Enviando...",
    portfolioButton: "Discuta seu projeto",

    // Portfolio Projects
    portfolioMagentoTitle: "E-commerce Magento",
    portfolioMagentoDesc:
      "Loja online completa com sistema de pagamento integrado e gestão avançada do catálogo de produtos",
    portfolioWordPressTitle: "Site Corporativo WordPress",
    portfolioWordPressDesc:
      "Site empresarial responsivo com CMS personalizado, SEO otimizado e sistema avançado de gestão de conteúdo",
    portfolioReactTitle: "Aplicação Web React",
    portfolioReactDesc:
      "Aplicação web moderna SPA com dashboard administrativo, autenticação e API REST integrada",
    portfolioMechanicalTitle: "Design Mecânico e CNC",
    portfolioMechanicalDesc:
      "Design mecânico utilizando SolidWorks, Fusion 360 e tecnologias de impressão 3D para prototipagem e produção industrial",
    portfolioITSupportTitle: "Suporte de TI",
    portfolioITSupportDesc:
      "Especializado em suporte de helpdesk de TI, manutenção de sistemas e resolução de problemas técnicos complexos",
  },
};

jQuery(document).ready(function ($) {
  console.log("DOM ready, initializing animations...");

  $(".slider").slick({
    dots: true,
    arrows: true,
  });

  const toggle = document.getElementById("menuToggle");
  const menu = document.querySelector(".header__menu");

  if (toggle && menu) {
    toggle.addEventListener("click", () => {
      menu.classList.toggle("active");
      toggle.classList.toggle("active");
    });
  }

  // Language Management
  let currentLanguage = localStorage.getItem("language") || "it";

  function translatePage(lang) {
    currentLanguage = lang;
    localStorage.setItem("language", lang);

    // Add transition class
    document.body.classList.add("language-switching");

    setTimeout(() => {
      // Update all elements with data-translate attribute
      document.querySelectorAll("[data-translate]").forEach((element) => {
        const key = element.getAttribute("data-translate");
        if (translations[lang] && translations[lang][key]) {
          element.innerHTML = translations[lang][key];
        }
      });

      // Update elements with data-translate-attr attribute (for alt texts, etc)
      document.querySelectorAll("[data-translate-attr]").forEach((element) => {
        const attrData = element.getAttribute("data-translate-attr");
        const [attr, key] = attrData.split(":");
        if (translations[lang] && translations[lang][key]) {
          element.setAttribute(attr, translations[lang][key]);
        }
      });

      // Update language selector
      const flags = { it: "🇮🇹", en: "🇺🇸", pt: "🇧🇷" };
      const codes = { it: "IT", en: "EN", pt: "PT" };

      const flagElement = document.getElementById("current-lang-flag");
      const textElement = document.getElementById("current-lang-text");

      if (flagElement && textElement) {
        flagElement.textContent = flags[lang];
        textElement.textContent = codes[lang];
      }

      // Remove transition class
      setTimeout(() => {
        document.body.classList.remove("language-switching");
      }, 100);

      console.log(`Language changed to: ${lang}`);
    }, 150);
  }

  // Initialize language on page load
  translatePage(currentLanguage);

  // Language selector event listeners
  document.querySelectorAll(".lang-option").forEach((option) => {
    option.addEventListener("click", (e) => {
      e.preventDefault();
      const lang = e.target.getAttribute("data-lang");
      if (lang) {
        translatePage(lang);
      }
    });
  }); // Theme Toggle Functionality
  const themeToggle = document.getElementById("theme-toggle");
  const htmlElement = document.documentElement;

  // Check for saved theme preference or default to 'dark'
  const currentTheme = localStorage.getItem("theme") || "dark";
  htmlElement.setAttribute("data-theme", currentTheme);

  if (themeToggle) {
    themeToggle.addEventListener("click", () => {
      const currentTheme = htmlElement.getAttribute("data-theme");
      const newTheme = currentTheme === "dark" ? "light" : "dark";

      htmlElement.setAttribute("data-theme", newTheme);
      localStorage.setItem("theme", newTheme);

      // Add smooth transition effect
      htmlElement.style.transition =
        "background-color 0.3s ease, color 0.3s ease";
      setTimeout(() => {
        htmlElement.style.transition = "";
      }, 300);
    });
  }

  // Detect system theme preference
  if (window.matchMedia && !localStorage.getItem("theme")) {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: light)");
    htmlElement.setAttribute(
      "data-theme",
      mediaQuery.matches ? "light" : "dark"
    );

    mediaQuery.addEventListener("change", (e) => {
      if (!localStorage.getItem("theme")) {
        htmlElement.setAttribute("data-theme", e.matches ? "light" : "dark");
      }
    });
  }

  // reCAPTCHA v3 Configuration and Execution
  const RECAPTCHA_SITE_KEY =
    window.RECAPTCHA_SITE_KEY || "6LdHdbgcAAAAAM-4l4I-PhDqXpksK5dqj-hkmB-Y";

  async function executeRecaptcha() {
    try {
      // Check if grecaptcha is loaded
      if (typeof grecaptcha === "undefined") {
        console.warn("reCAPTCHA not loaded. Proceeding without verification.");
        return null;
      }

      // Wait for reCAPTCHA to be ready
      await new Promise((resolve) => {
        grecaptcha.ready(resolve);
      });

      // Execute reCAPTCHA
      const token = await grecaptcha.execute(RECAPTCHA_SITE_KEY, {
        action: "contact_form",
      });

      console.log("reCAPTCHA token generated successfully");
      return token;
    } catch (error) {
      console.error("reCAPTCHA execution failed:", error);
      return null;
    }
  }

  // Contact Form Validation and Submission
  const contactForm = document.getElementById("contact-form");

  if (contactForm) {
    const formFields = {
      name: document.getElementById("name"),
      email: document.getElementById("email"),
      subject: document.getElementById("subject"),
      message: document.getElementById("message"),
    };

    // Validation patterns
    const patterns = {
      name: /^[a-zA-ZÀ-ÿ\s]{2,50}$/,
      email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      subject: /^.{3,100}$/,
      message: /^.{10,1000}$/,
    };

    // Error messages
    const errorMessages = {
      name: "Il nome deve contenere solo lettere e spazi (2-50 caratteri)",
      email: "Inserisci un indirizzo email valido",
      subject: "Il soggetto deve contenere 3-100 caratteri",
      message: "Il messaggio deve contenere almeno 10 caratteri",
    };

    // Real-time validation
    Object.keys(formFields).forEach((fieldName) => {
      const field = formFields[fieldName];
      const feedback = field.parentNode.querySelector(".invalid-feedback");

      field.addEventListener("blur", () =>
        validateField(fieldName, field, feedback)
      );
      field.addEventListener("input", () => {
        if (field.classList.contains("is-invalid")) {
          validateField(fieldName, field, feedback);
        }
      });
    });

    function validateField(fieldName, field, feedback) {
      const value = field.value.trim();
      const pattern = patterns[fieldName];

      if (!value) {
        setFieldError(field, feedback, "Questo campo è obbligatorio");
        return false;
      }

      if (!pattern.test(value)) {
        setFieldError(field, feedback, errorMessages[fieldName]);
        return false;
      }

      setFieldValid(field, feedback);
      return true;
    }

    function setFieldError(field, feedback, message) {
      field.classList.remove("is-valid");
      field.classList.add("is-invalid");
      feedback.textContent = message;
      feedback.classList.add("show");
    }

    function setFieldValid(field, feedback) {
      field.classList.remove("is-invalid");
      field.classList.add("is-valid");
      feedback.classList.remove("show");
    }

    // Form submission
    contactForm.addEventListener("submit", async (e) => {
      e.preventDefault();

      // Validate all fields
      let isValid = true;
      Object.keys(formFields).forEach((fieldName) => {
        const field = formFields[fieldName];
        const feedback = field.parentNode.querySelector(".invalid-feedback");
        if (!validateField(fieldName, field, feedback)) {
          isValid = false;
        }
      });

      if (!isValid) {
        showFormFeedback(
          "Per favore, correggi gli errori prima di inviare",
          "error"
        );
        return;
      }

      // Show loading state
      const submitBtn = contactForm.querySelector('button[type="submit"]');
      const btnText = submitBtn.querySelector(".btn-text");
      const btnSpinner = submitBtn.querySelector(".btn-spinner");

      submitBtn.disabled = true;
      btnText.classList.add("d-none");
      btnSpinner.classList.remove("d-none");

      try {
        // Execute reCAPTCHA v3
        const recaptchaToken = await executeRecaptcha();

        if (!recaptchaToken) {
          throw new Error("reCAPTCHA verification failed");
        }

        // Set the token in the hidden field
        const tokenField = document.getElementById("recaptcha_token");
        if (tokenField) {
          tokenField.value = recaptchaToken;
        }

        // Prepare form data
        const formData = new FormData(contactForm);

        // Submit form to server
        const response = await fetch(contactForm.action, {
          method: "POST",
          body: formData,
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.text();

        // Check if submission was successful
        if (result.includes("success") || response.status === 200) {
          // Reset form and show success message
          contactForm.reset();
          Object.values(formFields).forEach((field) => {
            field.classList.remove("is-valid", "is-invalid");
          });

          showFormFeedback(
            "Messaggio inviato con successo! Ti risponderò al più presto.",
            "success"
          );
        } else {
          throw new Error("Server responded with error");
        }
      } catch (error) {
        console.error("Form submission error:", error);
        showFormFeedback(
          "Si è verificato un errore. Riprova più tardi.",
          "error"
        );
      } finally {
        // Reset button state
        submitBtn.disabled = false;
        btnText.classList.remove("d-none");
        btnSpinner.classList.add("d-none");
      }
    });

    function showFormFeedback(message, type) {
      const feedback = contactForm.querySelector(".form-feedback");
      feedback.className = `form-feedback ${type} show`;
      feedback.textContent = message;

      // Hide after 5 seconds
      setTimeout(() => {
        feedback.classList.remove("show");
      }, 5000);
    }
  }

  // Scroll animations
  const observerOptions = {
    threshold: 0.2,
    rootMargin: "0px 0px -100px 0px",
  };

  const animateOnScrollObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        console.log("Animating element:", entry.target);
        entry.target.classList.add("animate");
        animateOnScrollObserver.unobserve(entry.target);
      }
    });
  }, observerOptions);

  // Wait for DOM to be fully loaded
  setTimeout(() => {
    // Observe all elements with animate-on-scroll class
    const animatedElements = document.querySelectorAll(".animate-on-scroll");
    console.log("Found animated elements:", animatedElements.length);

    animatedElements.forEach((el) => {
      animateOnScrollObserver.observe(el);
    });

    // Immediate fallback for elements already in viewport
    animatedElements.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const isInViewport =
        rect.top < window.innerHeight * 0.8 && rect.bottom > 0;
      if (isInViewport && !el.classList.contains("animate")) {
        console.log("Immediate animation for:", el);
        el.classList.add("animate");
      }
    });

    // Extended fallback after 3 seconds for any remaining elements
    setTimeout(() => {
      animatedElements.forEach((el) => {
        const rect = el.getBoundingClientRect();
        const isAboveFold = rect.top < window.innerHeight && rect.bottom > 0;
        if (isAboveFold && !el.classList.contains("animate")) {
          console.log("Fallback animation for:", el);
          el.classList.add("animate");
        }
      });
    }, 3000);
  }, 500);

  // Smooth scrolling for anchor links
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute("href"));
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  });

  // Optimize images loading
  if ("loading" in HTMLImageElement.prototype) {
    // Native lazy loading supported
    console.log("Native lazy loading supported");
  } else {
    // Fallback for browsers that don't support native lazy loading
    const images = document.querySelectorAll('img[loading="lazy"]');
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src || img.src;
          img.classList.remove("lazy");
          observer.unobserve(img);
        }
      });
    });

    images.forEach((img) => imageObserver.observe(img));
  }

  // Performance monitoring
  if ("performance" in window && "getEntriesByType" in performance) {
    window.addEventListener("load", () => {
      setTimeout(() => {
        const perfData = performance.getEntriesByType("navigation")[0];
        console.log(
          "Page load time:",
          perfData.loadEventEnd - perfData.loadEventStart,
          "ms"
        );

        // Add loaded class to body for emergency fallback
        document.body.classList.add("loaded");
      }, 0);
    });
  } else {
    // Fallback for browsers without performance API
    window.addEventListener("load", () => {
      setTimeout(() => {
        document.body.classList.add("loaded");
      }, 100);
    });
  }

  // Ultimate emergency fallback
  setTimeout(() => {
    console.log("Emergency fallback triggered");
    document.body.classList.add("loaded");

    // Force animate all elements
    document
      .querySelectorAll(".animate-on-scroll:not(.animate)")
      .forEach((el) => {
        el.classList.add("animate");
      });
  }, 5000);
});
